import React from 'react'
import styled from 'styled-components'
import {Icon, IconTwitterX, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {GiftShopTemplateShareItemProps} from './GiftShopTemplateShareModalProps'

interface StyledContainerProps {
  loading?: number
}

const StyledContainer = styled.a<StyledContainerProps>`
  display: flex;
  padding: ${convertUnit(16)} ${convertUnit(20)};
  column-gap: ${convertUnit(20)};
  cursor: ${({loading}) => (loading ? 'wait' : 'pointer')};
`
const StyledIconContainer = styled.div`
  margin: 0 ${convertUnit(4.8)};
`
export default function GiftShopTemplateShareItem({
  stateLoading,
  icon,
  label,
  onClick,
}: GiftShopTemplateShareItemProps) {
  const loading = stateLoading[0]

  return (
    <StyledContainer
      loading={loading ? 1 : 0}
      onClick={!loading ? onClick : undefined}>
      {label === 'X' ? (
        <StyledIconContainer>
          <IconTwitterX height={convertUnit(24)} width={convertUnit(24)} />
        </StyledIconContainer>
      ) : (
        <Icon size={24} type={icon} />
      )}
      <Paragraph fontSize="m" fontWeight="medium">
        {label}
      </Paragraph>
    </StyledContainer>
  )
}
